import { motion } from 'framer-motion';
import { AlertCircle } from './icons';
import { supabase } from '../lib/supabase';

interface PausedAccessScreenProps {
  title?: string;
  message?: string;
  subMessage?: string;
  signOutLabel?: string;
}

export function PausedAccessScreen({
  title = 'Your Access Is Paused',
  message = 'Your coach has temporarily paused your access to the platform.',
  subMessage = 'Your results and history are safely stored. Please contact your coach if you\u2019d like to resume access.',
  signOutLabel = 'Sign Out',
}: PausedAccessScreenProps) {
  return (
    <div className="min-h-screen freud-bg py-8 px-6 flex items-center justify-center">
      <div className="max-w-lg mx-auto w-full">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          className="freud-card-elevated p-10 text-center"
        >
          <div className="w-16 h-16 bg-warm-100 rounded-2xl flex items-center justify-center mx-auto mb-6">
            <AlertCircle className="w-8 h-8 text-warm-600" />
          </div>
          <h2 className="freud-heading-xl text-chocolate-900 mb-4">{title}</h2>
          <p className="freud-text-base text-chocolate-500 mb-2 max-w-md mx-auto">
            {message}
          </p>
          <p className="text-sm text-chocolate-400 mb-8 max-w-md mx-auto">
            {subMessage}
          </p>
          <button
            onClick={() => supabase.auth.signOut()}
            className="freud-btn-secondary"
          >
            {signOutLabel}
          </button>
        </motion.div>
      </div>
    </div>
  );
}
